import React, { useEffect, useState } from "react";
import Header from "../../utils/components/Header/Header";
import { GetRequest, PostRequest } from "../../utils/repository/RequestMaker";
import axios from "axios";
import Endpoints from "../../utils/repository/Endpoints";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./Subscription.css";

function SubscriptionDetails() {
  const [subscriptionDetails, setSubscriptionDetails] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const user = useSelector((state) => state.login.user);
  useEffect(() => {
    fetchSubscriptioDetails();
  }, []);

  const fetchSubscriptioDetails = () => {
    GetRequest("/get_subscription")
      .then((response) => {
        console.log(response);
        setSubscriptionDetails(response.subscription);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const cancelSubscription = () => {
    PostRequest(
      { subscriptionId: user.subscription_id },
      Endpoints.cancel_subscription
    )
      .then((response) => {
        console.log(response);
        setModalIsOpen(false);
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  return (
    <div>
      <Header logout={true} />

      <div className="d-flex justify-content-center mt-3">
        <h5>Abonnementdetails</h5>
      </div>
      <div className="d-flex justify-content-center mt-3">
        <div className="card align-items-center" style={{ width: "40%" }}>
          <div className="d-flex mt-3">
            <p className="text-secondary" style={{ marginRight: "5px" }}>
              Abonnementstatus:{" "}
            </p>
            {subscriptionDetails.status === "ACTIVE" && (
              <p className="text-success">{subscriptionDetails.status}</p>
            )}
            {subscriptionDetails.status === "CANCELLED" && (
              <p className="text-danger">{subscriptionDetails.status}</p>
            )}
          </div>
          <p className="text-secondary">
            Abonnement-ID: {user.subscription_id}
          </p>
          <p className="text-secondary">
            Startdatum des Abonnements:{" "}
            {new Date(subscriptionDetails.start_time).toDateString()}
          </p>
          <p className="text-secondary">
            Nächster Zahlungstermin:{" "}
            {new Date(subscriptionDetails.next_billing_time).toDateString()}
          </p>
        </div>
      </div>
      {subscriptionDetails.status === "ACTIVE" && (
        <div className="d-flex justify-content-center mt-3">
          <button type="button" className="btn btn-css" onClick={openModal}>
            Abonnement Beenden
          </button>
          <button
            type="button"
            style={{ marginLeft: "10px" }}
            className="btn btn-css"
          >
            <a href="/" className="a-css">
              Back
            </a>
          </button>
        </div>
      )}
      {subscriptionDetails.status === "CANCELLED" && (
        <div className="d-flex justify-content-center mt-3">
          <Link to="/">
            <button type="button" className="btn btn-css">
              Back
            </button>
          </Link>
        </div>
      )}

      <div>
        {modalIsOpen && (
          <div
            className="modal"
            style={{
              display: "block",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1000,
            }}
          >
            <div
              className="modal-dialog"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                marginRight: "-50%",
                transform: "translate(-50%, -50%)",
                width: "50%",
                backgroundColor: "white",
                maxHeight: "80%",
                overflow: "auto",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                zIndex: 1000,
              }}
            >
              <div className="modal-content">
                <div className="modal-header d-flex justify-content-center">
                  <h6 className="modal-title">Cancel Subscription</h6>
                </div>
                <div className="modal-body d-flex justify-content-center mt-3">
                  <p>Are you sure you want to cancel?</p>
                </div>
                <div className="modal-footer d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn btn-css"
                    onClick={closeModal}
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-css"
                    onClick={cancelSubscription}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SubscriptionDetails;
